<template>

  <a-row
    type="flex"
    v-if="dataSource"
    style="
      margin-top: 20px;
      margin-bottom: 20px;
      border: 1px solid #1796f1;
      padding: 5px;
      border-radius: 10px;
    "
  >
  
    <a-col :span="24" style="padding: 5px">
  
      <citizen-list 
        :compStyle="{ maxHeight: '500px' }"
        :citizenslist="dataSource"
        :selectable="true"
        @changeSelected="handleAppealSelChange"
      />
      
    </a-col>


    <a-col
 class="custom__content__area" 
      :span="16"
      v-if="dataSource && selectedApplicant "
      style="padding: 5px"
    >
    
      <div     style="padding: 5px; border: 1px solid #d3d3d3; border-radius: 5px;">
        <conditional-media  :filesList="selectedApplicant.files" />
      </div>
    </a-col>


    <a-col
    class="custom__aside__right"
      :span="8"
      v-if="dataSource && selectedApplicant"
      style="padding: 5px"
    >
   
      <div 
      
        style="
          padding: 5px;
          border: 1px solid #d3d3d3;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 370px;
          margin-bottom: 10px;
        "
      >
        <h4 style="font-size: 17.5px; font-weight: 500; margin-bottom: 10px">
         Müraciətə aid məlumatlar
        </h4>

        <div
          v-if="
            !selectedApplicant.appeals || selectedApplicant.appeals.length === 0
          "
        >
          Müraciət yoxdur
        </div>

        <div
          v-else
          style="width: 100%; height: calc(370px - 26px - 10px); overflow: auto"
        >
          <appeal-item
            v-for="(appeal, idx) in selectedApplicant.appeals"
            :key="idx"
            :appeal="appeal"
          />
        </div>
      </div>

      <div
        style="
          padding: 5px;
          border: 1px solid #d3d3d3;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 370px;
        "
        v-if="
          selectedApplicant.assestments &&
          selectedApplicant.assestments.length > 0
        "
      >
        <h4 style="font-size: 17.5px; font-weight: 500; margin-bottom: 10px">
          Qiymətləndirmə
        </h4>

        <div v-if="selectedApplicant.assestments.length === 0">
          İcra nəticəsi qiymətləndirilməyib
        </div>

        <div
          v-else
          style="width: 100%; height: calc(370px - 26px - 10px); overflow: auto"
        >
          <assestment-item
            v-for="(assestment, idx) in selectedApplicant.assestments"
            :key="idx"
            :assestment="assestment"
            @selected="handleSelectedAssestmentFilesChange"
          />
        </div>
      </div>
    </a-col>

    <a-modal
      title="Qiymətləndirmə faylları"
      v-model="assestmentFilesModalVis"
      :footer="null"
      :width="980"
      centered
    >
      <conditional-media :filesList="selectedAssestmentFiles" />
    </a-modal>
  </a-row>
</template>

<script>
import CitizenList from "@/components/partials/CitizenList/index";
import AppealItem from "@/components/partials/AppealItem/index";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
import AssestmentItem from "@/components/partials/AssestmentItem/index";

export default {
  name: "CitizenDetails",
  props: {
    dataSource: Array,
  },
  components: {
    "citizen-list": CitizenList,
    "appeal-item": AppealItem,
    "conditional-media": ConditionalMedia,
    "assestment-item": AssestmentItem,
  },
  data() {
    return {
      selectedApplicant: null,
      selectedAssestmentFiles: [],
      assestmentFilesModalVis: false,
    };
  },
  methods: {
    handleAppealSelChange(applicant) {
      this.selectedApplicant = applicant;
    },
    handleSelectedAssestmentFilesChange(files) {
      this.selectedAssestmentFiles = files;
      this.assestmentFilesModalVis = true;
    },
  },
  mounted() {
    // console.log(this.selectedApplicant);
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
